export const blogs = [
  {
    id: "senior-healthcare",
    title: "Caring Beyond Treatment: Senior Healthcare That Truly Cares",
    // subtitle: "Senior Healthcare That Truly Cares",
    author: "Yamini Dove",
    date: "April 2026",
    image: "/assets/blogs/blog1img.png",

    content: [
      {
        type: "paragraph",
        parts: [
          { text: "Growing older" },
          { text: " shouldn't mean more stress or endless hospital visits. It should mean " },
          { bold: "comfort, dignity, and peace of mind" },
          { text: "—for seniors and for their families." },
        ],
      },
      {
        type: "paragraph",
        parts: [
          { text: "At " },
          { bold: "HealthismPlus" },
          { text: ", we've seen how " },
          { bold: "small support makes a big difference" },
          { text: " after 60:" },
        ],
      },
      {
        type: "list",
        // blogs.js — replace the items array in the senior-healthcare blog
        items: [
          { bold: "Early checkups save lives", rest: " – Routine preventive health checkups help detect issues early, before they become serious." },
          { bold: "Care that continues from anywhere", rest: " – Order medicines with doorstep delivery and manage parents' health even when you're far away." },
          { bold: "No long hospital queues", rest: " – Book OPD appointments easily through our strong hospital network." },
          { bold: "Food as medicine", rest: " – Get personalised diet plans from trusted dieticians for healthy ageing." },
          { bold: "All reports in one safe place", rest: " – Securely store years of medical records in the app." },
          { bold: "Timely reminders that matter", rest: " – Never miss medicines, tests, or appointments." },
          { bold: "Doctor consultations from home", rest: " – Virtual consultations make healthcare accessible and stress free." },
        ],
      },
      {
        type: "paragraph",
        parts: [
          { text: "From medicines and appointments to reports and consultations—" },
          { bold: "everything is managed in one HealthismPlus app" },
          { text: ". Because " },
          { bold: "ageing gracefully starts with the right support" },
          { text: ". Choose HealthismPlus for senior friendly healthcare that goes beyond treatment." },
        ],
      },
      {
        type: "highlight",
        text: "One App. Fewer Worries.",
      },
      // ✅ AUTHOR WITH IMAGE
      {
        type: "author",
        name: "Yamini Dove",
        image: "/team/yamini.jpeg",
        role:
          "Co-Founder & Director",
        bio: `Dynamic professional with 8+ years operations experience, leading fulfillment, onboarding & service excellence with passion and precision.`,
      },
    ],
  },

  {
    id: "women-hormones",
    title: "Women Know Your Hormones",
    subtitle: "Understanding Hormones & Gut Health",
    author: "Naina Singhania",
    date: "April 2026",
    image: "/assets/blogs/blog2img.png",

    content: [
      {
        type: "paragraph",
        text: `Hormones and Gut Health are so tightly interlinked that if one of them is off the whack the other one will automatically start acting up too. No wonder, women who suffer from digestive symptoms are seen to have hormonal issues too.`,
      },
      {
        type: "paragraph",
        text: `For any woman who is menstruating, here is a small guide that you can use to really understand different phases of your menstrual cycle, what kind of climate it creates and the role each phase has physically and mentally.`,
      },

      // ✅ IMAGE BEFORE TABLE
      {
        type: "image",
        src: "/assets/blogs/blog2.1img.png",
        alt: "Menstrual Cycle Guide",
      },

      {
        type: "table",
        headers: [
          "Phases",
          "State of Being",
          "Physical",
          "Mental",
          "Type of Food",
        ],
        rows: [
          [
            "Menstruation",
            "Restful",
            "Relax and Rest",
            "Self-Reflect, Relax",
            "Micronutrient Dense, Warm Foods",
          ],
          [
            "Follicular",
            "Preparative",
            "Build Stamina (Cardio)",
            "Initiate, Strategize",
            "Low Calorie, Colourful, Moderate Fats",
          ],
          [
            "Ovulatory",
            "Opening up",
            "Strengthen (Weight, HIIT)",
            "Socialise, Ideate",
            "Detoxing, High Antioxidant",
          ],
          [
            "Luteal",
            "Work",
            "Strengthen and Stretch",
            "Organising, Completion",
            "Complex Carbs, Warm & Cooked Foods",
          ],
        ],
      },

      {
        type: "paragraph",
        text: `As a Dietitian working with women for over a decade, there are some symptoms that are very evident.`,
      },

      {
        type: "list",
        items: [
          "Bloating",
          "Acnes",
          "Cramps",
          "Constipation",
          "Sugar Cravings",
        ],
      },

      // ✅ AUTHOR WITH IMAGE
      {
        type: "author",
        name: "Naina Singhania",
        image: "/team/naina.jpeg",
        role:
          "Registered Dietitian | Functional Nutritionist | Diabetes Reversal Expert | Gut and Hormone Health Management",
        bio: `Naina is a Registered Dietitian of India practicing since 2013. She works in the field of Weight Management, Diabetes Reversals and Women’s Health (PCOS, Infertility) and Gut Health. She lives in Mumbai and caters to clients worldwide. Her approach is a combination of Ayurvedic Analysis along with scientific base in Functional Nutrition allows her to get into the root cause of the problem and provide customised solutions to her clients.`,
      },
    ],
  }
];